import { styled } from "@mui/material/styles"

import Column from "../../../../../common/components/Column"

export default styled(Column)(({ theme }) => ({
  marginTop: theme.spacing(3),
  paddingInline: theme.spacing(0.5),
  paddingBottom: theme.spacing(1),
  gap: theme.spacing(2),
}))
